
import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Body from './components/Body';

function App() {
  return (
    <>
    <Navbar/>
    <Body/>
    </>
  );
}

export default App;
